<template>
  <div
    :class="`${
      type === 'flex' ? 'flex items-center justify-between flex-wrap gap-1' : ''
    } bg-white p-2 mb-0.5 rounded-md border border-grayNeutralLight`"
  >
    <div class="flex items-center gap-1">
      <slot name="icon"></slot>
      <div class="font-bold">{{ label }}</div>
    </div>
    <div :class="`${type !== 'flex' ? 'mt-0.5' : 'font-medium'} text-grayNeutralDark`">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SummaryCard',
  props: {
    label: {
      type: String,
      required: true,
      default: '',
    },
    type: {
      type: String,
      default: 'flex',
    },
  },
}
</script>
